import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';

// 출발지·도착지 위의 작은 불러오기 버튼 — '의뢰자 정보 불러오기', '출발지 정보 불러오기'
const useStyles = makeStyles((theme) => ({
  root: {
    height: 30,
    padding: '0 12px',
    marginRight: 8,
    marginBottom: 10,
    borderRadius: 15,
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: '#ffffff',
    color: theme.palette.primary.dark,
    fontSize: 13,
    letterSpacing: -0.6,
    fontWeight: 700,
    transition: 'background-color .12s',
    '&:hover': { backgroundColor: '#fef7f5' },
    '&$disabled': {
      borderColor: '#e4e4e9',
      color: '#cacacf',
      backgroundColor: '#ffffff',
    },
  },
  disabled: {},
  icon: {
    width: 14,
    height: 14,
    marginRight: 5,
  },
}));

const ICONS = {
  user: <><circle cx="12" cy="8" r="3.6" /><path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" /></>,
  copy: <><rect x="8" y="8" width="11" height="12" rx="1.5" /><path d="M16 8V5.5A1.5 1.5 0 0 0 14.5 4h-8A1.5 1.5 0 0 0 5 5.5v9A1.5 1.5 0 0 0 6.5 16H8" /></>,
};

function QuickFillButton({ icon = 'user', children, onClick, disabled, className }) {
  const cs = useStyles();
  return (
    <ButtonBase
      className={clsx(cs.root, disabled && cs.disabled, className)}
      classes={{ disabled: cs.disabled }}
      onClick={onClick}
      disabled={disabled}
      focusRipple={false}
    >
      <svg className={cs.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {ICONS[icon]}
      </svg>
      {children}
    </ButtonBase>
  );
}

export default QuickFillButton;
